// Hub page content for the Business & Investment group.
// Sourced from docs/research/australian-visa-pathways.md §4. Overview level
// per DECISIONS D-001. Single service in this group for now.

const businessInvestmentHub = {
  groupSlug: "business-investment",
  eyebrow: "Business & Investment",
  heading: "Business and investment migration",
  intro:
    "Australia's business and investment migration landscape has shifted. The long-running Business Innovation and Investment Program is closed to new applicants, and the National Innovation visa now leads the field for exceptional individuals. We prepare and organise your file and match you with a registered migration agent who assesses whether a route genuinely fits you, without overselling a closed door.",

  howItWorks: {
    heading: "Where things stand",
    steps: [
      {
        title: "BIIP is closed",
        detail:
          "The Subclass 188 business and investor streams no longer take new applications.",
      },
      {
        title: "Existing cases continue",
        detail:
          "Applications lodged before the cut-off are still processed, with a path to the permanent 888.",
      },
      {
        title: "National Innovation visa",
        detail:
          "The Subclass 858 is the current premier, permanent route for exceptional talent.",
      },
      {
        title: "Often, another route fits",
        detail:
          "For many business people, a skilled or employer-sponsored visa is the more realistic path.",
      },
    ],
  },

  faqs: [
    {
      q: "Is there still a business or investor visa for new applicants?",
      a: "The Business Innovation and Investment Program is closed to new applications. The current premier route is the National Innovation visa, which is aimed at exceptionally talented people rather than at a set investment amount.",
    },
    {
      q: "Is the National Innovation visa realistic for me?",
      a: "It depends. It targets internationally recognised, exceptional achievement, and the bar is genuinely high. A registered migration agent assesses your profile before you commit time to it, and can point to skilled or sponsored alternatives where they fit better. We prepare and organise the evidence either way.",
    },
    {
      q: "Can you guarantee an outcome?",
      a: "No. The Department of Home Affairs decides, and the National Innovation visa is invitation-based and selective. A registered migration agent gives you an honest assessment, and we prepare and organise a strong, complete case.",
    },
  ],

  lastVerified: "13 July 2026",
};

export default businessInvestmentHub;
